export default function ComparisonSection() {
  const methods = [
    {
      name: 'Manual Browser Tabs',
      speed: 'Slow',
      organization: 'Poor',
      costControl: 'None',
      beginner: 'Easy',
      color: 'text-foreground-500',
    },
    {
      name: 'Notes App',
      speed: 'Medium',
      organization: 'Fair',
      costControl: 'Basic',
      beginner: 'Easy',
      color: 'text-foreground-500',
    },
    {
      name: 'Basetao Spreadsheet',
      speed: 'Fast',
      organization: 'Excellent',
      costControl: 'Advanced',
      beginner: 'Friendly',
      color: 'text-primary-600',
    },
    {
      name: 'Third-Party Tools',
      speed: 'Medium',
      organization: 'Good',
      costControl: 'Limited',
      beginner: 'Complex',
      color: 'text-foreground-500',
    },
  ];

  const labels = ['Method', 'Speed', 'Organization', 'Cost Control', 'Beginner Friendly'];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Basetao Spreadsheet vs Other Shopping Methods
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            See how the Basetao Spreadsheet approach compares against other common shopping organization methods.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200">
                {labels.map((label) => (
                  <th key={label} className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/70">
              {methods.map((method, i) => (
                <tr key={i} className={`${i === 2 ? 'bg-primary-50/50' : (i % 2 === 0 ? 'bg-background-50' : 'bg-background-100')}`}>
                  <td className={`px-5 py-3.5 font-semibold whitespace-nowrap ${method.color}`}>{method.name}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{method.speed}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{method.organization}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{method.costControl}</td>
                  <td className="px-5 py-3.5 text-foreground-600">{method.beginner}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}